<template>
	<el-drawer title="新增权限" :visible.sync="visible" :before-close="close" size="auto" class="punish-box">
		<div class="drawer-content">
			<el-form :model="formData" ref="formData" :rules="rules">
				<el-form-item prop="userId" label="绑定B类:">
					<el-select v-model="formData.userId" filterable remote  placeholder="请选择B类用户"
						:remote-method="searchUser" :loading="userLoading" size="medium" value-key="id" clearable>
						<el-option v-for="item in userList" :key="item.id"
							:label="`[${$userType.get(item.userType)}]${item.name}`" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
		<div class="drawer-footer">
			<el-button @click="close">取 消</el-button>
			<el-button type="primary" @click="submitForm" :loading="submitLoading">确认</el-button>
		</div>
	</el-drawer>
</template>

<script>
	import {
		fetchUser
	} from '@/assets/js/commonApi';
	const defaultFormData = {
		userId: ''
	}
	export default {
		props: {
			nicknameVisible: {
				type: Boolean,
				default: false
			}

		},
		data() {
			return {
				userList: [],
				userLoading: false,
				submitLoading: false,
				visible: false,
				formData: {
					...defaultFormData
				},
				rules: {
				    userId: [{ required: true, message: "请选择B类用户！" }]
				},
			}
		},
		watch: {

		},
		methods: {
			show() {
				this.visible = true;
			},
			close() {
				this.visible = false
			},
			// 搜索用户
			async searchUser(query) {
				if (query !== "") {
					this.userLoading = true;
					const res = await fetchUser({
						queryValue: query,
						userType: -1,
					}).finally(() => {
						this.userLoading = false;
					});

					const {
						state,
						result
					} = res.data;

					if (state == 1 && result) {
						this.userList = result;
					}
				}
			},
			submitForm() {
				
				this.$refs['formData'].validate((valid) => {
					if (valid) {
						this.submitLoading = true;
						this.$request({
							url: '/smsMarketing/privilege/on',
							method: "POST",
							params: {
								...this.formData
							}
						}).then(res => {
							const {
								state,
								msg
							} = res.data;
							if (state == 1) {
								this.$message.success('操作成功');
								this.close();
								this.$emit('onUpdate');
							} else {
								this.$message.error(msg || "请求失败");
							}
						}).catch(() => {
							this.$message.error("请求错误");
						}).finally(() => {
							this.submitLoading = false;
						})
					}
				})
			},

		}
	}
</script>